<template>
  <div class="callup">
    <div ref="security" class="auto">
      <div class="password"><label>Mot de passe d'accès aux convocations Seniors et U19 : </label>
        <input type="password" id="password" ref="password" maxlength="4" v-on:change="passwordChange" v-on:keyup="passwordChange">
      </div>
    </div>
    <div ref="callups">
      <div class="item box" v-for="item in callup" v-bind:key="item.pdf">
        <title class="color bold larger text-center row">{{item.text}}</title>
        <a target="_blank" :href="item.pdf">
          <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false">
            <template slot="loading">

            </template>
          </pdf>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Callup',
    components: {
      pdf
    },
    updated() {
      const editButtonRef = this.$refs.password;
      editButtonRef.focus();
      document.querySelector('.item').classList.add("hidden")
    },
    methods: {
      passwordChange() {
        console.log(this.$refs.password.value)
        if (btoa(this.$refs.password.value) == 'MTk5MQ==') {
          document.querySelector('.item').classList.remove("hidden")
          this.$refs.security.setAttribute("hidden", "hidden")
        }
      }
    },
    created() {
      this.callup = {};
      this.$root.$data.callup.all()
        .then(callup => {
          this.callup = _.map(callup, c => _.set(c, "pdf", _.get(c, "pdf") + "?u=" + new Date().getTime()))
        })
    },
    data() {
      return {
        callup: {},
      }
    },
  }
</script>

<style scoped lang="stylus">
  .callup
    title
      display block
    .item
      position relative
      max-width 920px
      margin auto
      &.hidden
        position fixed
        left -999px
    #password
      border 1px solid #5ea0e3
      width 40px
      font-size 20px
    .password
      display table
      margin auto
    .auto
      top 60px
      position relative
      width 100%
      height 150px
</style>
